import { EventBookingConfig } from './types';

export const defaultConfig: EventBookingConfig = {
  // id auto-généré par Prisma, ne pas l'envoyer
  slug: '',
  title: '',
  description: '',
  termsCgv: '',
  termsRgpd: '',
  defaultViewMode: 'calendar',
  enableGeolocation: true,
  imageUrl: '',
  videoUrl: '',
  addressLine1: '',
  city: '',
  postalCode: '',
  country: '',
  defaultCapacity: 1,
  granularity: 'HOURLY',
  priceCents: 0,
  currency: 'EUR',
  visible: true,
  businessDaysJSON: ['MON','TUE','WED','THU','FRI'],
  appointmentRulesJSON: [],
  ticketCategories: [],
  coupons: [],

  // Apparence
  primaryColor: '#4f46e5',
  backgroundColor: '#ffffff'
};
